/**
 * Contact Form 7：送信前確認ステップ（メタル #inquiry-metal / カメラ #inquiry-camera）
 * 「送信内容のご確認」クリックで確認表示に切り替え、戻る／送信するで制御
 * フォームごとにセクションを分けており競合しない
 */
document.addEventListener('DOMContentLoaded', () => {
  const formConfigs = [
    { sectionId: 'inquiry-metal', contactFormId: '246' },
    { sectionId: 'inquiry-camera', contactFormId: '247' },
  ];

  const mailSentHandlers = {};

  formConfigs.forEach((config) => {
    const section = document.querySelector(`#${config.sectionId}`);
    if (!section) return;

    const form = section.querySelector('form.wpcf7-form');
    const pForm = section.querySelector('.p-form');
    if (!form || !pForm) return;

    const confirmStepWrap = pForm.querySelector('.js-confirm-step-wrap');
    const confirmStepBtn = pForm.querySelector('.js-confirm-step');
    const confirmWrap = pForm.querySelector('.js-confirm-wrap');
    const backBtn = pForm.querySelector('.js-back-btn');
    const sentMsg = pForm.querySelector('.js-sent-msg');

    if (!confirmStepWrap || !confirmStepBtn || !confirmWrap || !backBtn) return;

    const textInputs = pForm.querySelectorAll(
      'input:not([type="hidden"]):not([type="checkbox"]), textarea',
    );

    /** 確認画面を解除して入力画面に戻す（送信完了メッセージは表示しない） */
    function resetConfirmView() {
      pForm.classList.remove('js-check');
      section.classList.remove('is-confirm-view');
      confirmStepWrap.setAttribute('aria-hidden', 'false');
      confirmWrap.setAttribute('aria-hidden', 'true');
      textInputs.forEach((el) => el.removeAttribute('readonly'));
      if (sentMsg) {
        sentMsg.classList.remove('is-visible');
        sentMsg.setAttribute('aria-hidden', 'true');
      }
    }

    /** 送信完了時の処理：確認解除 ＋ 「送信しました」表示 */
    function onMailSent() {
      const currentSection = document.querySelector(`#${config.sectionId}`);
      const currentPForm = currentSection && currentSection.querySelector('.p-form');
      if (!currentPForm) return;

      const currentConfirmStepWrap = currentPForm.querySelector('.js-confirm-step-wrap');
      const currentConfirmWrap = currentPForm.querySelector('.js-confirm-wrap');
      const currentTextInputs = currentPForm.querySelectorAll(
        'input:not([type="hidden"]):not([type="checkbox"]), textarea',
      );
      const currentSentMsg = currentPForm.querySelector('.js-sent-msg');

      currentPForm.classList.remove('js-check');
      currentSection.classList.remove('is-confirm-view');
      if (currentConfirmStepWrap) currentConfirmStepWrap.setAttribute('aria-hidden', 'false');
      if (currentConfirmWrap) currentConfirmWrap.setAttribute('aria-hidden', 'true');
      currentTextInputs.forEach((el) => el.removeAttribute('readonly'));

      if (currentSentMsg) {
        currentSentMsg.classList.add('is-visible');
        currentSentMsg.setAttribute('aria-hidden', 'false');
      }
    }

    mailSentHandlers[config.contactFormId] = onMailSent;

    // 「送信内容のご確認」クリック → 確認画面表示
    confirmStepBtn.addEventListener('click', (e) => {
      e.preventDefault();
      pForm.classList.add('js-check');
      section.classList.add('is-confirm-view');
      confirmStepWrap.setAttribute('aria-hidden', 'true');
      confirmWrap.setAttribute('aria-hidden', 'false');
      textInputs.forEach((el) => el.setAttribute('readonly', 'readonly'));
      if (sentMsg) {
        sentMsg.classList.remove('is-visible');
        sentMsg.setAttribute('aria-hidden', 'true');
      }
    });

    // 「戻る」クリック → 入力画面に戻す
    backBtn.addEventListener('click', resetConfirmView);
  });

  // 送信完了時：contactFormId に応じて該当フォームのみ解除・「送信しました」表示
  document.addEventListener('wpcf7mailsent', (e) => {
    const id = e.detail && e.detail.contactFormId != null ? String(e.detail.contactFormId) : '';
    const handler = mailSentHandlers[id];
    if (!handler) return;
    setTimeout(() => handler(), 0);
  });
});
